import { Button } from "components/Button"
import { PlusSquareRegular } from "components/Icon"
import { useRouter } from "components/Router"
import { useTranslator } from "components/Translator"

export const AdvertAddButton = () => {
  const translator = useTranslator()
  const router = useRouter()

  return (
    <Button
      href={router.generate("app_user_advert_add")}
      iconLeft={<PlusSquareRegular className="w-4" />}
    >
      {translator.trans("AdvertAddButton.label", null, "components")}
    </Button>
  )
}
